(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rv-product-detail'))customElements.define('rv-product-detail',class extends HTMLElement{
 connectedCallback(){this.controller?.abort();this.controller=new AbortController();const select=this.querySelector('select[name="id"]');if(!select)return;const update=()=>{const option=select.selectedOptions[0];if(!option)return;this.querySelector('[data-price]').textContent=option.dataset.price;const compare=this.querySelector('[data-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;const button=this.querySelector('[data-purchase]');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.availableLabel;const quantity=this.querySelector('input[name="quantity"]');quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);};select.addEventListener('change',update,{signal:this.controller.signal});}
 disconnectedCallback(){this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();
})();
